export default __webpack_public_path__ + "static/Corprate_WhoWeAre_IF_mbheader-48a4846d0aec48d32148ea172546c7a6.jpg";